// List of available Report Jobs that can be created or filtered
// @TODO to be deprecated
export const REPORT_JOB_TYPES = [
    {
        id: 'discount',
        name: 'Discounts Report',
        long_name: 'Discounts Report',
        description: `Assembles total discounts used and amount discounted by location, and assembles VIP Customers who have used discounts and amount they saved.`,
        instructions: `Enter a Name and Description for this Report Job. Select a Date Range and Time Zone Offset, and apply additional Location filters.`,
        package: 'discounts',
        class: 'DiscountReports',
        method: 'generate_combined_xls',
        type: 'Discount Report',
        worker_package: 'discounts'
    },
    {
        id: 'inventory-levels',
        name: 'Inventory Levels Report',
        long_name: 'Inventory Levels Report',
        description: `Assembles all Locations with positive, negative, or zero inventory and compiles a csv for each.`,
        instructions: `Enter a Name and Description for this Report Job.`,
        package: 'inventory',
        class: 'InventoryReports',
        method: 'generate_pieces_qty_export',
        type: 'Location Inventory Levels Report',
        worker_package: 'inventory'
    },
    {
        id: 'loyalty',
        name: 'Loyalty Accounts Report',
        long_name: 'Loyalty Accounts Report',
        description: `Assembles Loyalty Account signups during a specified period.`,
        instructions: `Enter a Name and Description for this Report Job. Select a Date Range, and whether to view active or fraud-locked Accounts.`,
        package: 'loyalty',
        class: 'LoyaltyReports',
        method: 'generate_account_export_csv',
        type: 'Loyalty Report',
        worker_package: 'loyalty'
    },
    {
        id: 'loyalty-top-earners',
        name: 'Loyalty Report - Top Earners',
        long_name: 'Loyalty Report - Top Earners',
        description: `Assembles the top-earning Loyalty Accounts during a specified period.`,
        instructions: `Enter a Name and Description for this Report Job. Select a Date Range and how many results to generate.`,
        package: 'loyalty',
        class: 'LoyaltyReports',
        method: 'generate_top_export',
        type: 'Loyalty Report',
        worker_package: 'loyalty'
    },
    {
        id: 'combined-sales',
        name: 'Combined Sales Report',
        long_name: 'Combined Sales Report',
        description: `Assembles a list of Locations with totals, averages, and daily sales during a specified period.`,
        instructions: `Enter a Name and Description for this Report Job. Select a Date Range and Time Zone Offset, and apply additional Location filters.`,
        package: 'sales',
        class: 'SalesReports',
        method: 'generate_combined_sales',
        type: 'Combined Sales Report',
        worker_package: 'sales'
    },
];

// Job Statuses and text equivalents
export const REPORT_JOB_STATUSES = {
    canceled: {id: 'canceled', name: 'Canceled'},
    completed: {id: 'completed', name: 'Completed'},
    error: {id: 'error', name: 'Error'},
    in_process: {id: 'in_process', name: 'In Process'},
    pending: {id: 'pending', name: 'Pending'},
};

// Job Custom Types
export const REPORT_JOB_CUSTOM_TYPES = [
    'bool',
    'float',
    'int',
    'list',
    'str',
    'City',
    'Cities',
    'DateString',
    'DateFromTo',
    'Day',
    'DBA',
    'DBAs',
    'District',
    'Districts',
    'Month',
    'Location',
    'Locations',
    'LocationType',
    'LocationTypes',
    'MonthDay',
    'ProductType',
    'State',
    'States',
    'System',
    'TextArea',
    'Year'
];

// Job Element Types in List
export const REPORT_JOB_LIST_TYPES = {
    City: 'str',
    Cities: 'str',
    DateFromTo: 'str',
    DBA: 'str',
    DBAs: 'str',
    District: 'str',
    Districts: 'str',
    Location: 'str',
    Locations: 'str',
    ProductType: 'str',
    State: 'str',
    States: 'str'
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/reportJobLists.js